import Listener from '../../core/watcher/Listener'
import './_style.scss'
import FacebookShare from '../../core/social/FacebookShare'

Listener.onLoadDOM(() => {
   const selector = '.js-socialFacebook'
   if (document.querySelector(selector)) {
      new FacebookShare(document.querySelector(selector))
   } else {
      console.log('selector "' + selector + '" is NULL')
   }
})